module.exports = __webpack_public_path__ + "media/bet_success.327c0e9b.mp3";